import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    // debug: true,
    resources: {
      'en-US': {
        translation: {
          'download':'Download',
          'cancel':'Cancel',
          'modal-title': 'Customize Your Document',
          'preview': 'Preview',
          'logo-drop': 'Drag your logo here, or click to select',
          'waiting-message': 'Please wait while your document is generated',
        },
      },
      'en-GB': {
        translation: {
          'Personal Strategies': 'Personal Strategies',
          'intro-text': 'Analyse and track your favorite portfolios.',
        }
      },
    },
  });

export default i18n;